import { Link } from "react-router-dom";
import { Target, Heart, Award, Leaf, CheckCircle2 } from "lucide-react";
import { COMPANY, VALUES, IMAGES } from "../data/site";
import { Reveal, Overline, PageHeader } from "../components/Reveal";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="À propos"
        title="MS Énergie, votre partenaire énergétique de confiance"
        subtitle="Une entreprise locale à taille humaine, spécialisée dans les systèmes énergétiques pour les particuliers et les professionnels du Maine-et-Loire."
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-24 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <img src={IMAGES.maintenance} alt="Technicien MS ÉNERGIE réalisant l'entretien et le contrôle d'une installation à Angers" className="rounded-3xl w-full h-[460px] object-cover shadow-xl border border-border" />
        </Reveal>
        <Reveal delay={0.15}>
          <Overline>Notre histoire</Overline>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-navy mt-4">Le confort durable, notre métier</h2>
          <div className="space-y-4 text-text-muted mt-6 leading-relaxed">
            <p>
              Chez MS Énergie, nous mettons notre expertise technique au service de votre confort thermique. De l'installation de votre climatisation à la maintenance de votre pompe à chaleur, nous vous accompagnons à chaque étape.
            </p>
            <p>
              Notre conviction : un travail soigné, des conseils honnêtes et des solutions performantes qui réduisent vos consommations tout en respectant l'environnement.
            </p>
          </div>
          <div className="flex items-center gap-3 mt-7 text-brand font-bold">
            <Leaf className="w-5 h-5" /> Engagés pour une énergie plus responsable
          </div>
        </Reveal>
      </section>

      <section className="bg-surface border-y border-border py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <Overline>Nos valeurs</Overline>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-navy mt-4">Ce qui nous distingue</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.06}>
                <div className="bg-white border border-border rounded-2xl p-6 h-full text-center">
                  <div className="w-12 h-12 rounded-xl bg-navy flex items-center justify-center mx-auto">
                    <v.icon className="w-6 h-6 text-brand" />
                  </div>
                  <h3 className="font-display font-bold text-navy mt-4">{v.title}</h3>
                  <p className="text-text-muted text-sm mt-2">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-24">
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { icon: Target, t: "Notre mission", d: "Offrir des solutions énergétiques fiables, performantes et adaptées à chaque logement." },
            { icon: Heart, t: "Notre engagement", d: "La satisfaction client avant tout : écoute, transparence et suivi après intervention." },
            { icon: Award, t: "Notre exigence", d: "Un matériel de qualité, des finitions soignées et des techniciens qualifiés." },
          ].map((b, i) => (
            <Reveal key={b.t} delay={i * 0.1}>
              <div className="bg-navy text-white rounded-2xl p-8 h-full">
                <b.icon className="w-9 h-9 text-brand" />
                <h3 className="font-display font-bold text-xl mt-5">{b.t}</h3>
                <p className="text-white/60 text-sm mt-3 leading-relaxed">{b.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-16">
          <Link to="/devis" className="bg-brand text-white font-bold py-4 px-8 rounded-full hover:bg-brand-dark transition-colors">
            Demander un devis gratuit
          </Link>
        </div>
      </section>
    </div>
  );
}
